import { mode } from "@chakra-ui/theme-tools";

export const inputStylesGray = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "8px",
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("white", "navy.900")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
            _invalid: {
              borderColor: "red",
              boxShadow: "0 0 0 1px red",
            },
            _focusVisible: {
              borderColor: mode("gray.400", "gray.200")(props),
              boxShadow: mode("0 0 0 1px var(--chakra-colors-gray-400)", "0 0 0 1px var(--chakra-colors-gray-200)")(props),
            }
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("white", "navy.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("white", "navy.800")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
      },

      defaultProps: {
        variant: "main",
      },
    },
    NumberInput: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("white", "navy.900")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
            _invalid: {
              borderColor: "red",
              boxShadow: "0 0 0 1px red",
            },
            _focusVisible: {
              borderColor: mode("gray.400", "gray.200")(props),
              boxShadow: mode("0 0 0 1px var(--chakra-colors-gray-400)", "0 0 0 1px var(--chakra-colors-gray-200)")(props),
            }
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("white", "navy.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("white", "navy.800")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("white", "navy.900")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
            _invalid: {
              borderColor: "red",
              boxShadow: "0 0 0 1px red",
            },
            _focusVisible: {
              borderColor: mode("gray.400", "gray.200")(props),
              boxShadow: mode("0 0 0 1px var(--chakra-colors-gray-400)", "0 0 0 1px var(--chakra-colors-gray-200)")(props),
            }
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("white", "navy.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("white", "navy.800")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "transparent")(props),
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("gray.300", "gray.400")(props) },
          },
        }),
      },
      
      defaultProps: {
        variant: "main",
      },
    },
    Textarea: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "8px",
        },
      },

      variants: {
        main: (props) => ({
          bg: mode("white", "navy.900")(props),
          border: "1px solid",
          borderColor: mode("gray.200", "transparent")(props),
          _placeholder: { color: mode("gray.300", "gray.400")(props) },
          _invalid: {
            borderColor: "red",
            boxShadow: "0 0 0 1px red",
          },
          _focusVisible: {
            borderColor: mode("gray.400", "gray.200")(props),
            boxShadow: mode("0 0 0 1px var(--chakra-colors-gray-400)", "0 0 0 1px var(--chakra-colors-gray-200)")(props),
          },
        }),
      },
      defaultProps: {
        variant: "main",
      },
    },
  },
};
